module.exports = __webpack_public_path__ + "img/4.79825d1a.jpg";